import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Button, Col, Form, Input, Label, Modal, Row, UncontrolledAlert } from 'reactstrap'
import Papa from "papaparse";
import EmailLocationMapTableContainer from 'components/Common/EmailLocationMapTableContainer';
import LocationMapImportContext from './LocationMapImportContext';
import LoadingOverlay from 'react-loading-overlay';
import Error from 'pages/NotificationModal/Error';
import Success from './Success';
import { FormFeedback } from "reactstrap"

function ImportForm() {
    const { loading, success, error, setSuccess, setError, submitImport, setLoading, importResponse } = useContext(LocationMapImportContext)
    const [data, setData] = useState(null)
    const [rawData, setRawData] = useState()
    const [inputFile, setInputFile] = useState()
    const [inputKey, setInputKey] = useState(Date.now())
    const [errorMsg, setErrorMsg] = useState()
    const [apptSysName, setApptSysName] = useState("")
    const [touched, setTouched] = useState(false)


    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (!file) return;
        setRawData(null)
        setInputFile(file)
        setLoading(true)
        Papa.parse(file, {

            complete: (result) => {
                const cleanedData = result.data.map(row => {
                    const cleanedRow = {};
                        Object.keys(row).forEach(key => {
                        const cleanKey = key.replace(/^\uFEFF/, ''); // remove BOM
                        cleanedRow[cleanKey] = row[key];
                });
            return cleanedRow;
        });
        setRawData(cleanedData);
        console.log(rawData)
        setLoading(false)
            },
            header: true,
            skipEmptyLines: true,
        });
    };

    useEffect(() => {
        console.log("Updated rawData:", rawData);
        setData(null)
        if (rawData?.length > 200) {
            setErrorMsg("Can not have more than 200 records")
        } else if (rawData?.length == 0) {
            setErrorMsg("Input file has no valid records.")
        } else {
            setErrorMsg(null)
            setData(rawData)
        }

    }, [rawData, errorMsg]);

    const handleFileCleanup = () => {
        setInputFile(null)
        setData(null)
        setInputKey(Date.now());
    }

    const getColumns = () => {
        return useMemo(
            () => [
                {
                    accessor: "ADDRESSLINE1",
                    Header: "Address Line1",
                },
                {
                    accessor: "CITY",
                    Header: "City",
                },
                {
                    accessor: "STATE",
                    Header: "State",
                },
                {
                    accessor: "ZIP",
                    Header: "Zip",
                },
                {
                    accessor: "LOCATION_NAME",
                    Header: "Location Name",
                },
                {
                    accessor: "LOCATION_CODE",
                    Header: "Location Code",
                },
                {
                    accessor: "LOCATION_EMAILS",
                    Header: "Emails"
                },
                {
                    accessor: "REFERENCE_NUMBERS",
                    Header: "Reference Numbers",
                },
                {
                    accessor: "EMAIL_TEMPLATE",
                    Header: "Template",
                },
            ],
            []
        )
    }

    const column = getColumns()

    const handleSubmit = () => {
        if (!apptSysName) {
            setErrorMsg("Appointment System Type is required")
            return
        }
        if (!data || data.length === 0) {
            setErrorMsg("Please upload a valid file")
            return
        }

        const emailLocMaps = data.map((item) => {
            return {
                'addr1': item.ADDRESSLINE1,
                'city': item.CITY,
                'state': item.STATE,
                'zipCode': item.ZIP,
                'locName': item.LOCATION_NAME,
                'tenant': item.TENANT,
                'locCode': item.LOCATION_CODE,
                'template': item.EMAIL_TEMPLATE,
                'refNumbers': item.REFERENCE_NUMBERS,
                'locEmails': item.LOCATION_EMAILS,
                'apptSystem': apptSysName,
                'allowUncleansedAddress': item.ALLOW_UNCLEANSED_ADDR ? item.ALLOW_UNCLEANSED_ADDR : false

            }
        })
        let obj = {
            'data': emailLocMaps
        }
        submitImport(obj)
    }

    const closeSuccess = () => {
        setSuccess(false)
        handleFileCleanup()
    }

    const handleSelectGroup = event => {
        setApptSysName(event.target.value)
    }

    const togError = () => {
        setError(false)
    }
    return (
        <>
            <Modal
                isOpen={success}
                toggle={() => {
                    togSuccess()
                }}
                centered
                size="md"
            >
                <Success
                    data={importResponse} cancel={closeSuccess}
                />
            </Modal>
            <Modal
                isOpen={error}
                toggle={() => {
                    togError()
                }}
                centered
                size="sm"
            >
                <Error
                    message="Something went wrong"
                    closeModal={togError}
                />
            </Modal>
            <LoadingOverlay active={loading} spinner>
                <Row className="mb-2">
                    <Label
                        htmlFor="horizontal-firstname-Input"
                        className="col-sm-3 col-form-label"
                    >
                        Appointment System Type
                    </Label>
                    <Col sm={6}>
                        <select
                            value={apptSysName}
                            name="apptSysName"
                            className={`form-control ${touched && !apptSysName ? "is-invalid" : ""}`}
                            onChange={e =>
                                handleSelectGroup(e)
                            }
                            onBlur={() => setTouched(true)}
                            required
                        >
                            <option value={null}>Select</option>
                            <option value='EMAIL'>
                                EMAIL
                            </option>
                            <option value='ONENETWORK'>
                                ONENETWORK
                            </option>
                        </select>
                        {touched && !apptSysName && (
                            <FormFeedback className="invalid">
                                Appointment System Type is required
                            </FormFeedback>
                        )}

                    </Col>
                </Row>


                <Row className="mb-2">
                    <Label
                        htmlFor="horizontal-firstname-Input"
                        className="col-sm-3 col-form-label"
                    >
                        Input File
                    </Label>
                    <Col sm={6}>
                        <div className='d-flex gap-2'>
                            <Input className="form-control" key={inputKey} type="file" accept=".csv" onChange={handleFileChange} />
                            <Button onClick={handleFileCleanup} className='btn btn-sm' color='secondary' disabled={!inputFile}>Clear</Button>
                        </div>
                        <div className='mt-2'>
                            {errorMsg && (
                                <div className="mb-3">
                                    <UncontrolledAlert color="danger" role="alert">
                                        {errorMsg}
                                    </UncontrolledAlert>
                                </div>
                            )}
                        </div>

                    </Col>
                </Row>



                {data && data.length > 0 &&
                    <div className='border p-2'>
                        <EmailLocationMapTableContainer columns={column} data={data} customPageSize={20} />
                    </div>
                }
                <div className='modal-footer mt-3'>
                    <div className='d-flex gap-2'>
                        <Button onClick={handleSubmit} className='btn ' color='primary' disabled={!data || data.length == 0}>Submit</Button>
                        <Button onClick={handleFileCleanup} className='btn ' color='secondary' >Cancel</Button>
                    </div>
                </div>
            </LoadingOverlay>
        </>
    )
}

export default ImportForm